'use strict'

import api from "@/api/api";
import userService from "../../services/user.service";
import { CONSTANTS, getErrorMessage } from "../../global/index";

const {
  CLEAR_DATA,
  GETTING_INFO,
  GET_INFO_SUCCESS,
  SET_HISTORY_OPTION,
  SET_ADDED,
  SET_STATUS,
  ERROR_MSG,
  ERROR_STATUS,
  CLEAN_VALUE,
} = CONSTANTS;

const ERROR_OBJ = {
  success: false,
  status: ERROR_STATUS,
  code: 500,
  message: ERROR_MSG,
  data: null
};

export default {
    namespaced: true,
    state: {
        loading: false,
        data: [],
        historyOption: "Default",
        status: "",
        added: "",
    },
    getters: {
        loading(state) {
            return state.loading;
        },
        data(state) {
            return state.data;
        },
        getHistoryOption(state) {
            return state.historyOption;
        },
        getAdded(state) {
            return state.added;
        },
        status(state) {
            return state.status;
        },
    },
    mutations: {
        [GETTING_INFO](state) {
            state.loading = true;
            state.data = [];
        },
        [CLEAR_DATA](state) {
            state.data = [];
        },
        [GET_INFO_SUCCESS](state, change) {
            state.loading = false;
            state.data = change;
        },
        [SET_HISTORY_OPTION](state, change) {
           state.historyOption = change;
        },
        [SET_ADDED](state, change) {
           state.added = change;
        },
        [SET_STATUS](state, value) {
          state.status = value;
        },
        [CLEAN_VALUE](state, value) {
           state.data = value;
        },
    },
    actions:{
        setAddedPqt({commit}, payload){
            commit(SET_ADDED, payload);
        },

        setHistoryOptionPqt({commit}, payload){
            commit(SET_HISTORY_OPTION, payload);  
        },
        async getAllInfoPqt({ commit }, payload) {
            commit(GETTING_INFO);

            try {
                const token = userService.getToken();
                const headers = { Authorization: token };
                const response = await api.getAllInfo(payload, headers);
                commit(GET_INFO_SUCCESS, response.data.data);

                return response.data;
            } catch (error) {
                commit(GET_INFO_SUCCESS, []);
                if(!error?.response?.data?.message) return  ERROR_OBJ;
                return getErrorMessage(error.response.data.message)
            }
        },

        async getInfoByIdPqt({ commit }, payload) {
            commit(GETTING_INFO);
            try {
                const token = userService.getToken();
                const headers = { Authorization: token };
                const response = await api.getInfoById(payload, headers);
                commit(GET_INFO_SUCCESS, response.data.data);
        
                return response.data.data;
            } catch (error) {
                commit(GET_INFO_SUCCESS, []);
                if(!error?.response?.data?.message) return  ERROR_OBJ;
                return getErrorMessage(error.response.data.message)
            }
        },

        async deleteItemPqt({ commit }, payload) { 
            commit(SET_STATUS, "SUCCESS");
            try {
                const token = userService.getToken();
                const headers = { Authorization: token };
                const response = await api.deleteItem(payload, headers);
                return response.data;
            } catch (error) {
                if(!error?.response?.data?.message) return  ERROR_OBJ;
                return getErrorMessage(error.response.data.message)
            }
        },
        async editItemPqt({ commit }, payload) { 
            commit(SET_STATUS, "SUCCESS");
    
            try {
                const token = userService.getToken();
                const headers = { Authorization: token };
                const response = await api.editItem(payload, headers);
                return response.data;
            } catch (error) {
                if(!error?.response?.data?.message) return  ERROR_OBJ;
                return getErrorMessage(error.response.data.message)
            }
        },

        async gettingInfo({ commit }) {
            commit(GETTING_INFO);
        },
        clearData({ commit }) {
            commit(CLEAR_DATA);
        },

        async addItemPqt({ commit }, payload) { 
            commit(SET_STATUS, 'SUCCESS')
            commit(GETTING_INFO);
            try {               
                const token = userService.getToken();
                const headers = { Authorization: token };
                const response = await api.addItem(payload, headers);
                if(!response.data.success){
                    commit(GET_INFO_SUCCESS, []);
                }
                return response.data;
            } catch (error) {
                console.log(error);
                commit(GET_INFO_SUCCESS, []);
                 if(!error?.response?.data?.message) return  ERROR_OBJ;
                return getErrorMessage(error.response.data.message)
            }
           
        },

        async getPaqueterias({ commit }, payload) {
            commit(GETTING_INFO);
            try {               
                const token = userService.getToken();
                const headers = { Authorization: token };
                const response = await api.addItem(payload, headers);

                if(!response.data.success){
                    commit(GET_INFO_SUCCESS, []);
                }else{
                    commit(GET_INFO_SUCCESS, response.data.data);
                }
                
                return response.data;
            } catch (error) {
                  console.log(error);
                commit(GET_INFO_SUCCESS, [])
                if(!error?.response?.data?.message) return  ERROR_OBJ;
                return getErrorMessage(error.response.data.message)
            }
        },
    },
}